<template>
  <div class="xrow">
    <div class="form-group">
      <div class="col-1-1">
        <label for>Nome do grupo <span class="message">*</span></label>
        <input type="text" class="form-control" v-model="form.nome" />
      </div>
      <div class="col-1-2 mt-2">
        <div class="form-group">
          <label>Sistemas <span class="message">*</span></label>
          <div v-for="sistema in sistemasDisponiveis">
            <label class="checkbox">
              <input
                type="checkbox"
                class="mr-1"
                :value="form[sistema.chave]"
                v-bind:checked="!!form[sistema.chave]"
                v-on:change="handleSistemaChecked(sistema.chave)"
              />
              {{ sistema.descricao }}
            </label>
          </div>
        </div>
      </div>
      <div class="col-1-2 mt-2">
        <div class="form-group">
          <label for="">Ativo? <span class="message">*</span></label>
          <select class="form-control" v-model="form.ativo">
            <option value="1">Sim</option>
            <option value="0">Não</option>
          </select>
        </div>
      </div>
      <div class="col-1-1 mt-1">
        <div class="form-group">
          <label>Prioridade <span class="message">*</span></label>
          <div class="checkbox mb-3">
            <div v-for="(_, index) in new Array(10)">
              <button
                :class="{ 'btn-info': index + 1 === form.prioridade }"
                class="btn mr-2"
                @click="setPrioridade(index + 1)"
              >
                {{ index + 1 }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { find } from "lodash";
import { toggleValue } from "../../../../helpers/utils";

export default {
  name: "InformacoesGerais",
  props: {
    form: { type: Object, required: true },
  },
  components: {},
  data() {
    return {
      sistemasDisponiveis: [
        {
          chave: "aplicacallcenter",
          descricao: "Callcenter",
        },
        {
          chave: "aplicafv",
          descricao: "Força de vendas",
        },
      ],
    };
  },
  methods: {
    handleSistemaChecked(chave) {
      this.form[chave] = !!this.form[chave] ? 0 : 1;
    },
    setPrioridade(number) {
      this.form.prioridade = number;
    },
  },
};
</script>
